export const HeartIconFill = ({
  className,
  alt = "heart icon filled",
}: {
  className?: string;
  alt?: string;
}) => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>{alt}</title>
      <path
        d="M5.57891 1.04688C8.02149 1.04688 9.99987 2.97099 9.99987 5.34462C9.99987 2.97099 11.9782 1.04688 14.4208 1.04688C16.8634 1.04688 18.8418 2.97099 18.8418 5.34462C18.8418 8.92206 15.2674 10.184 10.4331 15.8785C10.3799 15.941 10.3136 15.9913 10.2387 16.0258C10.1639 16.0603 10.0824 16.0781 9.99987 16.0781C9.91736 16.0781 9.83584 16.0603 9.76101 16.0258C9.68618 15.9913 9.61984 15.941 9.56662 15.8785C4.7323 10.184 1.15796 8.92206 1.15796 5.34462C1.15796 2.97099 3.13634 1.04688 5.57891 1.04688Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};
